var _path, _path2, _path3, _rect, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectListingScore2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6663 15.25C25.6623 15.25 22.4163 12.0041 22.4163 8C22.4163 3.99594 25.6623 0.75 29.6663 0.75C33.6704 0.75 36.9163 3.99594 36.9163 8C36.9163 12.0041 33.6704 15.25 29.6663 15.25Z",
    fill: "#D5D6D8",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3336 15.25C20.3296 15.25 17.0836 12.0041 17.0836 8C17.0836 3.99594 20.3296 0.75 24.3336 0.75C28.3377 0.75 31.5836 3.99594 31.5836 8C31.5836 12.0041 28.3377 15.25 24.3336 15.25Z",
    fill: "#D5D6D8",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 15.25C14.9969 15.25 11.751 12.0041 11.751 8C11.751 3.99594 14.9969 0.75 19.001 0.75C23.005 0.75 26.251 3.99594 26.251 8C26.251 12.0041 23.005 15.25 19.001 15.25Z",
    fill: "#D5D6D8",
    stroke: "white",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.41633,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#78BB96",
    stroke: "white",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.08365,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#78BB96",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33365 8L7.33365 10L11.3336 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListingScore2);
export default __webpack_public_path__ + "static/media/project-listing-score-2.bae403ee09b94f77ddbb14f6b6204346.svg";
export { ForwardRef as ReactComponent };